<template>
  <a-modal
    title="图片预览"
    destroy-on-close
    :width="900"
    :maskClosable="false"
    :visible="visible"
    :footer="null"
    @cancel="onCancel"
  >
    <ahai-preview-img :img-list="imgList" :img-index="imgIndex"/>
  </a-modal>
</template>

<script>
import AhaiPreviewImg from '@/components/AhaiPreviewImg'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    imgList: {
      type: Array,
      default: () => []
    },
    imgIndex: {
      type: Number,
      default: 0
    }
  },
  components: { AhaiPreviewImg },
  methods: {
    onCancel() {
      this.$emit('update:visible', false)
    }
  }
}
</script>
